var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AbsBox',{staticStyle:{"background":"#fff"}},[_c('AbsBox',{style:(_vm.style)}),_c('BGImage',{attrs:{"opacity":_vm.image.opacity,"repeat":_vm.image.repeat,"url":_vm.image.url,"size":_vm.image.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }